import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './passwordConfiguration.actions';
import { DEFAULT_PASSWORD_CONFIGURATION, PasswordConfigurationState } from './passwordConfiguration.types';

const initialState: PasswordConfigurationState = {
	value: DEFAULT_PASSWORD_CONFIGURATION,
	isLoaded: false,
	isLoading: false,
	isSaving: false,
	error: null,
};

const passwordConfigurationReducer = createReducer<PasswordConfigurationState, ActionType<typeof actions>>(initialState)
	.handleAction(actions.fetchPasswordConfiguration.request, (state) => ({
		...state,
		error: null,
		isLoading: true,
	}))
	.handleAction(actions.fetchPasswordConfiguration.success, (state, action) => ({
		...state,
		error: null,
		isLoading: false,
		isLoaded: true,
		value: action.payload.passwordConfiguration,
	}))
	// A failed fetch deliberately leaves `value` alone rather than resetting it: the initial
	// value is already the weakest policy, and clobbering a value that did load would make a
	// transient error look like a policy change.
	.handleAction(actions.fetchPasswordConfiguration.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isLoading: false,
		isLoaded: true,
	}))
	.handleAction(actions.savePasswordConfiguration.request, (state) => ({
		...state,
		error: null,
		isSaving: true,
	}))
	.handleAction(actions.savePasswordConfiguration.success, (state, action) => ({
		...state,
		error: null,
		isSaving: false,
		isLoaded: true,
		value: action.payload.passwordConfiguration,
	}))
	.handleAction(actions.savePasswordConfiguration.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		isSaving: false,
	}))
	.handleAction(actions.resetPasswordConfiguration, () => initialState);

export { passwordConfigurationReducer };
